module.exports = __webpack_public_path__ + "static/media/haute15A.4d8d1fb2.jpg";